// @ts-nocheck
import { api } from './index';

export const loginUser = (payload) => api.post('/user/login', payload);
